module.exports = __webpack_public_path__ + "img/innovator-entrepreneur-1.8b7ff59c.svg";